import { IS_IOS, LIGHT_DOWNLOAD_IOS } from './index';
import { TEMPLATE_SHARE } from './channelSource';

const templateShareChannel = {
  android: 'https://service-adhoc.dji.com/download/app/android/b6b7eb73-2ee9-43b0-a8fd-e36a4bf2d2a4',
  iOS: 'https://apps.apple.com/app/apple-store/id1517555997?pt=121648964&ct=modelshare&mt=8',
};

/*
 *@Description: 打开app时带的额外参数，ios带from来判断下载页面所取的url，安卓带adhoc下载地址，不带地址jsbridge有默认
*/
export const jumpExtraParam = (from, param = {}) => {
  switch (from) {
    case TEMPLATE_SHARE:
      if (IS_IOS) {
        const { query = {}, path = '' } = param;
        const queryObj = Object.assign({}, query, { from });
        return Object.assign({}, path ? { path } : {}, { query: queryObj });
      }
      return Object.assign({}, param, { androidDownloadUrl: templateShareChannel.android });
    default:
      break;
  }
  return null;
};

/*
 *@Description: outsideH5下载页面的渠道地址
*/
export const getIOSDownloadUrl = (from) => {
  switch (from) {
    case TEMPLATE_SHARE:
      return templateShareChannel.iOS;
    default:
      break;
  }
  return LIGHT_DOWNLOAD_IOS;
};
